<template>
  <ul class="nav o-nav-light">
    <slot />
  </ul>
</template>

<script>
export default {
  name: 'WptvMenu'
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.nav {
  &.o-nav-light {
    display: inline-flex;
    flex-wrap: unset;
  }
}
</style>
